module.exports = __webpack_public_path__ + "img/part5-1.48957551.png";